module.exports = __webpack_public_path__ + "img/35.38a11575.png";